import { render, staticRenderFns } from "./ModalVisualizarCamadasVinculadas.vue?vue&type=template&id=81a5ed84&lang=pug"
import script from "./ModalVisualizarCamadasVinculadas.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarCamadasVinculadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports